/* eslint-disable import/prefer-default-export */
import { HttpError, HttpSuccess } from 'signature-public-api-sdk';
import to from 'await-to-js';
import { resetUserData } from '€slices/data/data-thunks';
import { AppThunk } from '€slices/types';
import { timeout } from './network-slice';

export const callApi =
    <S>(
        req: Promise<HttpSuccess<S>>,
    ): AppThunk<Promise<[HttpError, S | null, HttpSuccess<S> | null]>> =>
    async dispatch => {
        const [error, success] = await to<HttpSuccess<S>, HttpError>(req);

        if (error != null && error.statusCode && error.statusCode === 401) {
            dispatch(timeout());
            dispatch(resetUserData());
        }

        return [error, success && success.data, success];
    };
